import type { FilterValue } from "@/components/Table/Filters";
import { Display_Value_Key as dvk } from "@/components/Create/utils";
import type { UserModel } from "@/database";

export type UploadedByValue = "all" | "myuploads" | "myteam" | "otherteam";

export const UPLOADED_BY_OPTIONS: { value: UploadedByValue; label: string }[] = [
  { value: "all", label: "All" },
  { value: "myuploads", label: "Me" },
  { value: "myteam", label: "My team" },
  { value: "otherteam", label: "External" },
];

export function getUploadedByValue(
  filters: Record<string, FilterValue>,
  user: UserModel | null
): UploadedByValue {
  if (!user) return "all";
  const { ctby, team, must_not } = filters as any;
  if (Array.isArray(ctby) && ctby.some((id: string) => id === user.id)) {
    return "myuploads";
  }
  if (
    must_not &&
    typeof must_not === "object" &&
    Array.isArray(must_not.team) &&
    must_not.team.some((t: string) => t === user.team)
  ) {
    return "otherteam";
  }
  if (Array.isArray(team) && team.some((t: string) => t === user.team)) {
    return "myteam";
  }
  return "all";
}

/** Returns a new filters object with uploaded-by keys rewritten for `value`. */
export function withUploadedBy(
  filters: Record<string, FilterValue>,
  value: UploadedByValue,
  user: UserModel | null,
  getProductNameById: (id: string) => string
): Record<string, FilterValue> {
  const next: Record<string, FilterValue> = { ...filters };
  delete (next as any).must_not;
  delete next.ctby;
  delete (next as any)[`ctby${dvk}`];
  delete next.team;
  delete (next as any)[`team${dvk}`];

  if (!user) return next;
  if (value === "myuploads" && user.id) {
    next.ctby = [user.id];
    (next as any)[`ctby${dvk}`] = user.name ?? "";
  } else if (value === "myteam" && user.team) {
    next.team = [user.team];
    (next as any)[`team${dvk}`] = getProductNameById(user.team);
  } else if (value === "otherteam" && user.team) {
    (next as any).must_not = { team: [user.team] };
  }
  delete (next as any).page;
  return next;
}
